import { productPriceStyles } from "@WhiteCap/Overrides/Components/ProductPrice";
import { css } from "styled-components";

// EC-27 : Sub Task - 553 Cart Page 
// Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments.
productPriceStyles.priceWrapper = {
	css: css`
		span{
			font-family: inherit;
		}
	`
}

productPriceStyles.priceLabelText = {
	variant: "legend",
	css: css`
		font-family: inherit;
	`
}

//End: Refactored dynamic CSS from CMS to code for consistent behavior across environments.